export default {
  Processando: 1,
  Sucesso: 2,
  Falha: 3,
  Cancelado: 4,
  EmCancelamento: 5,
  Enfileirado: 6,
};
